import { IterableTrackEventSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../../contract';
import { IterableProfileSchema } from '../../types/IterableWrapper';

export const iterableWrapperRouter = c.router(
  {
    pushUpdateUserData: {
      summary: 'Pushes user data meant to update Galatea Iterable profile. Requests will be queued and processed',
      method: 'POST',
      path: '/update-user',
      body: IterableProfileSchema,
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    pushTrackEvent: {
      summary: 'Pushes an Iterable event. Requests will be queued and processed',
      method: 'POST',
      path: '/track-event',
      body: IterableTrackEventSchema,
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    pushTrackEventForUser: {
      summary: 'Pushes an Iterable event for a specified user. Requests will be queued and processed',
      method: 'POST',
      path: '/track-event-for-user',
      body: z.object({
        userId: z.string(),
        eventName: z.enum(['authorWallTagged', 'authorWallReplyReceived']),
        dataFields: z.record(z.string(), z.unknown()).optional(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    pushUpdateUsersData: {
      summary: 'Pushes many users data meant to update Galatea Iterable profile. Requests will be queued and processed',
      method: 'POST',
      path: '/update-users',
      body: z.array(IterableProfileSchema).min(1),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix: '/iterable-wrapper' },
);
